//No Day
import dateFormat from 'dateformat';

const toShortDateTimeString = (dateStr) => {
  const date = new Date(dateStr);
  return dateFormat(date,"mmm dd yyyy")
}

export default toShortDateTimeString;
